import { classNames } from './class-names';

export interface ClassNamesParts {
  prefix?: string;
  component: string;
  element?: string;
  modifier?: string;
  index?: string | number | false;
}

const PREFIX = 'es';

export const createReadableClass = (
  { prefix = PREFIX, component, element, modifier, index }: ClassNamesParts,
  additionalClasses: Array<string | boolean | undefined> = []
): string => {
  let readableClass = prefix;

  readableClass += component ? `-${component}` : '';
  readableClass += element ? `-${element}` : '';
  readableClass += modifier ? `-${modifier}` : '';
  readableClass += index ? ` ${readableClass}-${index}` : '';

  return classNames(readableClass, {}, additionalClasses);
};
